var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6644_213937",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6644_213937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2 20.4504C39.2 19.0322 39.0728 17.6686 38.8364 16.3594H20V24.0958H30.7636C30.3 26.5958 28.891 28.714 26.7728 30.1322V35.1504H33.2364C37.0182 31.6686 39.2 26.5412 39.2 20.4504Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0017 39.9969C25.4017 39.9969 29.9289 38.2059 33.2379 35.1515L26.7743 30.1333C24.9835 31.3333 22.6925 32.0423 20.0017 32.0423C14.7925 32.0423 10.3835 28.5241 8.81071 23.7969H2.12891V28.9787C5.41991 35.5151 12.1835 39.9969 20.0017 39.9969Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.809 23.7974C8.409 22.5974 8.1818 21.3156 8.1818 19.9974C8.1818 18.6792 8.409 17.3974 8.809 16.1974V11.0156H2.1272C0.772799 13.7156 0 16.7702 0 19.9974C0 23.2246 0.772799 26.2792 2.1272 28.9792L8.809 23.7974Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0017 7.9546C22.9379 7.9546 25.5743 8.9636 27.6471 10.9454L33.3835 5.209C29.9199 1.9818 25.3925 0 20.0017 0C12.1835 0 5.41991 4.4818 2.12891 11.0182L8.81071 16.2C10.3835 11.4728 14.7925 7.9546 20.0017 7.9546Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.cc867fb8d7ffcaa98f1b6ac6e177ef5e.svg";
export { ForwardRef as ReactComponent };